import {inject, Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslocoService} from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messageService = inject(MessageService);
  private translator = inject(TranslocoService);

  public showInfo(message: string, translated = true, sticky = false, title?: string) {
    if (translated) message = this.translator.translate(message);
    let summary = this.translator.translate('toast.info');
    if (title) summary = this.translator.translate(title);
    this.messageService.add({severity: 'info', summary: summary, detail: message, sticky});
  }

  public showSuccess(message: string, translated = true, sticky = false, title?: string) {
    if (translated) message = this.translator.translate(message);
    let summary = this.translator.translate('toast.success');
    if (title) summary = this.translator.translate(title);
    this.messageService.add({severity: 'success', summary: summary, detail: message, sticky});
  }

  public showError(message: string, translated = true, sticky = false, title?: string) {
    if (translated) message = this.translator.translate(message);
    let summary = this.translator.translate('toast.error');
    if (title) summary = this.translator.translate(title);
    this.messageService.add({severity: 'error', summary: summary, detail: message, sticky});
  }

  public showWarning(message: string, translated = true, sticky = false, title?: string) {
    if (translated) message = this.translator.translate(message);
    let summary = this.translator.translate('toast.warning');
    if (title) summary = this.translator.translate(title);
    this.messageService.add({severity: 'warn', summary: summary, detail: message, sticky});
  }

  public closeAll() {
    this.messageService.clear();
  }
}
